__turbopack_context__.v({
  "title": "related-topics-module-scss-module__pPAlVa__title",
});
